import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import strings from 'strings';
import { FPActionButton } from 'UI/components/atoms';
import AutocompleteSelect from 'UI/components/molecules/AutocompleteSelect';
import { Endpoints } from 'UI/constants/endpoints';

import { useConversationSearchModalStyles } from './EntitySelectionModal.styled';
import { ROLEPLAY_CALL_TARGET_OPTIONS } from './Roleplay.constants';

export const EntitySelectionModal = ({ onClose, onSelect, open }) => {
  const classes = useConversationSearchModalStyles();
  const [entityType, setEntityType] = useState(ROLEPLAY_CALL_TARGET_OPTIONS[0]);
  const [entity, setEntity] = useState(null);

  const handleClose = (_event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;

    onClose && onClose();
  };

  const handleSelect = (_name, value) => {
    setEntity(value);
  };

  const handleSelectEntityType = (_name, value) => {
    setEntityType(value);
    setEntity(null);
  };

  const handleConfirm = () => {
    onSelect && onSelect(entity);
    handleClose();
  };

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      fullWidth
      maxWidth="md"
      onClose={handleClose}
      open={open}
      scroll="paper"
    >
      <Box className={classes.header}>
        <Typography variant="h6">Roleplay Setup</Typography>
        <IconButton size="small" onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <DialogContent className={classes.dialogContent}>
        <AutocompleteSelect
          defaultOptions={ROLEPLAY_CALL_TARGET_OPTIONS}
          disableClearable
          freeSolo={false}
          name="entityType"
          onSelect={handleSelectEntityType}
          placeholder="Who are you calling?"
          selectedValue={entityType}
        />

        <AutocompleteSelect
          name="entity"
          onSelect={handleSelect}
          placeholder={entityType.placeholder}
          renderOption={entityType.renderOption}
          selectedValue={entity}
          typeahead
          typeaheadLimit={50}
          typeaheadParams={{ entityType: entityType.id }}
          url={Endpoints.Search}
        />
      </DialogContent>

      <DialogActions>
        <FPActionButton onClick={handleClose} text={strings.shared.ui.cancel} variant="outlined" />
        <FPActionButton
          disabled={!entity}
          onClick={handleConfirm}
          text={strings.shared.ui.continue}
        />
      </DialogActions>
    </Dialog>
  );
};
